
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive'
import {
    partypooper, pettranslator, pushcounter, phonefinder, hairclippersimulator, flashalertsoncallandmessage, screenprank, displayInfo, cuemotion
} from '../components/Images';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import Fade from 'react-reveal/Fade';

import Deck from '../components/Deck'
import '../styles/apps.css';



const apps = [
    {
        id: 'com.bianca.apps.screentestinfo',
        name: 'Display Info and Tester',
        description: 'Test your LCD and touch screen and shows all information about your display.',
        logo: displayInfo.logo,
        screen1: displayInfo.screen1,
        screen2: displayInfo.screen2,
        screen3: displayInfo.screen3,
        screen4: displayInfo.screen4,
        screen5: displayInfo.screen5,
        screen6: displayInfo.screen6,
        screen7: displayInfo.screen7,
    },
    {
        id: 'com.bianca.apps.flashlight.call.notification.alert',
        name: 'Flash Alerts - Call & Message',
        description: 'Phone flashes on calls, messages and notifications & flash visual effects tools.',
        logo: flashalertsoncallandmessage.logo,
        screen1: flashalertsoncallandmessage.screen1,
        screen2: flashalertsoncallandmessage.screen2,
        screen3: flashalertsoncallandmessage.screen3,
        screen4: flashalertsoncallandmessage.screen4,
        screen5: flashalertsoncallandmessage.screen5,
        screen6: flashalertsoncallandmessage.screen6,
        screen7: flashalertsoncallandmessage.screen7,
        
    },

    {
        id: 'com.eosrmg.apps.motionsicknessaid',
        name: 'CueMotion vehicle sickness aid',
        description: 'Visual cues to stabilize motion perception to lower sickness during vehicle move.',
        logo: cuemotion.logo,
        screen1: cuemotion.screen1,
        screen2: cuemotion.screen2,
        screen3: cuemotion.screen3,
        screen4: cuemotion.screen4,
        screen5: cuemotion.screen5,
        screen6: cuemotion.screen6,
        screen7: cuemotion.screen3,
       
    },
    {
        id: 'com.bianca.apps.brokenscreenprank',
        name: 'Screen prank, glitching lines',
        description: 'Prank your friends with realistic green lines broken screen and screen glitches.',
        logo: screenprank.logo,
        screen1: screenprank.screen1,
        screen2: screenprank.screen2,
        screen3: screenprank.screen3,
        screen4: screenprank.screen4,
        screen5: screenprank.screen5,
        screen6: screenprank.screen2,
        screen7: screenprank.screen6,

    },
    {
        id: 'com.bianca.apps.hairclippersimulatorprankjoke',
        name: 'Hair Clipper Razor Simulator',
        description: 'Prank your friends and simulate the sound and sensation of a real hair clipper.',
        logo: hairclippersimulator.logo,
        screen1: hairclippersimulator.screen1,
        screen2: hairclippersimulator.screen2,
        screen3: hairclippersimulator.screen3,
        screen4: hairclippersimulator.screen4,
        screen5: hairclippersimulator.screen5,
        screen6: hairclippersimulator.screen6,
        screen7: hairclippersimulator.screen7,
    },
    {
        id: 'com.bianca.apps.handclapfindmyphone',
        name: 'Find my phone: Clap your hands',
        description: 'Never lose your device again! The app locates it when you simply clap your hands.',
        logo: phonefinder.logo,
        screen1: phonefinder.screen1,
        screen2: phonefinder.screen2,
        screen3: phonefinder.screen3,
        screen4: phonefinder.screen4,
        screen5: phonefinder.screen5,
        screen6: phonefinder.screen6,
        screen7: phonefinder.screen7,
    },
    {
        id: 'com.bianca.apps.simulator.sounds.translator.simulator',
        name: 'Dog, Cat Translator & Sounds',
        description: 'Decode pet emotions, train & prank with our funny dog & cat sounds collections!',
        logo: pettranslator.logo,
        screen1: pettranslator.screen1,
        screen2: pettranslator.screen2,
        screen3: pettranslator.screen3,
        screen4: pettranslator.screen4,
        screen5: pettranslator.screen5,
        screen6: pettranslator.screen6,
        screen7: pettranslator.screen7,
    },
    {
        id: 'com.bianca.apps.counter.pushups.workout',
        name: 'Push Ups Challenge and Counter',
        description: 'Track Push ups effortlessly with our app. Stay organized, boost productivity!',
        logo: pushcounter.logo,
        screen1: pushcounter.screen1,
        screen2: pushcounter.screen2,
        screen3: pushcounter.screen3,
        screen4: pushcounter.screen4,
        screen5: pushcounter.screen5,
        screen6: pushcounter.screen6,
        screen7: pushcounter.screen7,
    },
    {
        id: 'com.bianca.apps.confetti.party.cannon',
        name: 'Confetti cannon party popper',
        description: 'Ignite joy with a virtual confetti explosion, confetti cannon now in your pocket!',
        logo: partypooper.logo,
        screen1: partypooper.screen1,
        screen2: partypooper.screen2,
        screen3: partypooper.screen3,
        screen4: partypooper.screen4,
        screen5: partypooper.screen5,
        screen6: partypooper.screen6,
        screen7: partypooper.screen3,
    }
];
export default function Apps() {
    const [installs, setInstalls] = useState({});
    const [genre, setGenre] = useState({});
    const [contentRating, setContentRating] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const appIds = apps.map(app => app.id).join(',');
                const response = await axios.get('https://app-installs-api.vercel.app/', {
                    params: { appIds }
                });

                const installsData = response.data.reduce((acc, app) => {
                    acc[app.appId] = app.installs;
                    return acc;
                }, {});
                setInstalls(installsData);

                const genreData = response.data.reduce((acc, app) => {
                    acc[app.appId] = app.genre;
                    return acc;
                }, {});
                setGenre(genreData);

                const contentRatingData = response.data.reduce((acc, app) => {
                    acc[app.appId] = app.contentRating;
                    return acc;
                }, {});
                setContentRating(contentRatingData);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <div className="Apps">
            {apps.map(app => (
                <div key={app.id} className="containerApp">
                    {isMobile ? (
                        <div className="appOne">
                            {/* Content without Fade for mobile */}
                            <div className="applogoOne">
                                <img src={app.logo} alt={app.name} width="80" height="80" style={{ borderRadius: '20%' }} />
                            </div>
                            <div className="headapp">
                                <div className="text">
                                    <h1>{app.name}</h1>
                                    <p>{app.description}</p>
                                </div>
                            </div>
                            <div className="appInfo">
                                <div className="downloads">
                                    <p>⬇️</p>
                                    <p>{installs[app.id] || 'Loading...'}</p>
                                </div>
                                <div className="genre">
                                    <p>{genre[app.id] || 'Loading...'}</p>
                                </div>
                                <div className="genre">
                                    <p>{contentRating[app.id] || 'Loading...'}</p>
                                </div>
                            </div>
                            <a className="install" href={`https://play.google.com/store/apps/details?id=${app.id}`}>
                                Install <FontAwesomeIcon icon={faGooglePlay} />
                            </a>
                        </div>
                    ) : (
                        <Fade left>
                            <div className="appOne">
                                {/* Content with Fade for desktop */}
                                <div className="applogoOne">
                                    <img src={app.logo} alt={app.name} width="80" height="80" style={{ borderRadius: '20%' }} />
                                </div>
                                <div className="headapp">
                                    <div className="text">
                                        <h1>{app.name}</h1>
                                        <p>{app.description}</p>
                                    </div>
                                </div>
                                <div className="appInfo">
                                    <div className="downloads">
                                        <p>⬇️</p>
                                        <p>{installs[app.id] || 'Loading...'}</p>
                                    </div>
                                    <div className="genre">
                                        <p>{genre[app.id] || 'Loading...'}</p>
                                    </div>
                                    <div className="genre">
                                        <p>{contentRating[app.id] || 'Loading...'}</p>
                                    </div>
                                </div>
                                <a className="install" href={`https://play.google.com/store/apps/details?id=${app.id}`}>
                                    Install <FontAwesomeIcon icon={faGooglePlay} />
                                </a>
                            </div>
                        </Fade>
                    )}

                    <div className="screensGallery">
                        {isMobile ? (
                            <Deck cardList={[app.screen1, app.screen2, app.screen3, app.screen4, app.screen5, app.screen6, app.screen7]} verticalDrag={true} />
                        ) : (
                            <Fade right>
                                <Deck cardList={[app.screen1, app.screen2, app.screen3, app.screen4, app.screen5, app.screen6, app.screen7]} verticalDrag={true} />
                            </Fade>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}